import { uniqBy } from 'lodash';

/**
 * The version one group was loaded at (CLD-2967/CONC-2, D21). The API reads it
 * server-side when the load is requested and returns it with the load; the
 * editor sends it back unchanged on publish, and the API validates it.
 */
export interface IBaseSubmission {
  GroupRowIdentifierID: number;
  BaseSubmissionID: number;
}

/**
 * Record the versions a load returned.
 *
 * A full reload (`replace`) starts again from what it returned. An
 * incremental load (inputs added to the editor) keeps the version already
 * recorded for a group: edits made on the earlier data were made against that
 * older version, so the save must name it. If live moved in between, the
 * promote is refused rather than silently overwriting the other change.
 */
export const mergeLoadedVersions = (
  current: IBaseSubmission[],
  loaded: IBaseSubmission[] | undefined,
  replace: boolean
): IBaseSubmission[] =>
  uniqBy(
    [...(replace ? [] : current), ...(loaded ?? [])],
    'GroupRowIdentifierID'
  );

export const buildPublishPayload = <T>(
  assumptions: T[],
  comment: string | undefined,
  baseSubmissions: IBaseSubmission[]
) => ({
  Assumptions: assumptions,
  Comment: comment ?? '',
  BaseSubmissions: baseSubmissions,
});
